import { ChartNoAxesCombined } from "lucide-react";

const manifest = {
  key: "incoming_offers_price_analysis_management",
  isFreeModule: false,
  isPurchasable: true,
  icon: ChartNoAxesCombined,
  names: {
    plan: {
      en: "Incoming Offers & Price Analysis Management",
      ar: "إدارة تحليل العروض والأسعار الواردة",
    },
    dashboard: {
      en: "Incoming Offers & Price Analysis Management",
      ar: "إدارة تحليل العروض والأسعار الواردة",
    },
  },
  defaultPath: "/incoming-offers-price-analysis-dashboard",
  matchers: [
    /^\/incoming-offers-price-analysis-dashboard(?:\/|$)/,
    /^\/received-proposals(?:\/|$)/,
  ],
  buildNavbarMenus: ({ t, activeModuleLabel }) => [
    {
      label: activeModuleLabel,
      path: "__incoming_offers_price_analysis__",
      children: [
        {
          label: t("menu_main_menu") || "Main Menu",
          path: "/dashboard",
        },
        {
          label: t("incoming_offers_analysis_menu_dashboard") || "Dashboard",
          path: "/incoming-offers-price-analysis-dashboard",
        },
        {
          label:
            t("menu_incoming_offers_price_analysis") ||
            "Incoming Offers & Price Analysis",
          path: "/received-proposals",
          permissions: ["view_all_incoming_offers"],
        },
      ],
    },
  ],
};

export default manifest;

